// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Selectors
import { getPoiType } from '../../poiSelector';

// Components
import SearchPointer from './SearchPointer';
import ActivityPointer from './ActivityPointer';
import ElementPointer from './ElementPointer';

// Constants
import { PoiType } from '../../poiConstants';

const PointerSwitch = (props) => {
    const { pointer } = props;

    switch (getPoiType(pointer)) {
        case PoiType.element:
            return <ElementPointer {...props} />;
        case PoiType.search:
            return <SearchPointer {...props} />;
        default:
            return <ActivityPointer {...props} />;
    }
};

PointerSwitch.propTypes = {
    pointer: PropTypes.object.isRequired,
    layerRect: PropTypes.object.isRequired,
};

export default PointerSwitch;
